import { render, staticRenderFns } from "./TimeLinePage.vue?vue&type=template&id=480e82a2"
import script from "./TimeLinePage.vue?vue&type=script&lang=js"
export * from "./TimeLinePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports